import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	associateFieldErrorTitleV2: {
		id: 'business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-title-v-2',
		defaultMessage: 'Unable to connect {fieldName} to issue types in this project',
		description:
			'Error title informing the user that associating the field with issue types failed.',
	},
	associateFieldErrorMessageV2: {
		id: 'business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-message-v-2',
		defaultMessage: 'Check your connection, then try again.',
		description:
			'Error message informing the user that associating the field with issue types failed.',
	},
	associateFieldTryAgainAction: {
		id: 'business-inline-field-config-sidebar.controllers.associate-field.associate-field-try-again-action',
		defaultMessage: 'Try again',
		description: 'A link to let the user do the action one more time.',
	},
	refetchFieldsErrorTitle: {
		id: 'business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-title',
		defaultMessage: '{fieldName} has been associated to issue types in the list view',
		description:
			'Error title informing the user they associated their field but the list view has not updated to show this',
	},
	refetchFieldsErrorMessage: {
		id: 'business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-message',
		defaultMessage: 'Wait a few moments and try refreshing your page to see the change.',
		description:
			'Error message informing the user they associated their field but the list view has not updated to show this',
	},
	successTitle: {
		id: 'business-inline-field-config-sidebar.controllers.associate-field.success-title',
		defaultMessage: 'Field association updated!',
		description: 'Title to the message that confirms the field association is successful',
	},
	successDescription: {
		id: 'business-inline-field-config-sidebar.controllers.associate-field.success-description',
		defaultMessage:
			'You can now use the <strong>{fieldName}</strong> field for your <strong>{issueType}</strong> issue type',
		description:
			'Tells the user that the field associated can now be used for this issue type being updated',
	},
});
